// extracted by mini-css-extract-plugin
export default {"inviteUsers":"assessment_users_inviteUsers__XotKj","centerEmailLogo":"assessment_users_centerEmailLogo__tfOZ-","inviteModalClass":"assessment_users_inviteModalClass__K-zDu"};